import { render, staticRenderFns } from "./disable.vue?vue&type=template&id=c54af72e"
import script from "./disable.vue?vue&type=script&lang=js"
export * from "./disable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports